export enum MconfigParentTypeEnum {
  Dashboard = 'Dashboard',
  ChartDialogDashboard = 'ChartDialogDashboard',
  SuggestDimensionDashboard = 'SuggestDimensionDashboard',
  Report = 'Report',
  ChartDialogReport = 'ChartDialogReport',
  SuggestDimensionReport = 'SuggestDimensionReport',
  Chart = 'Chart',
  SuggestDimensionChart = 'SuggestDimensionChart',
  SuggestDimensionModel = 'SuggestDimensionModel',
  Blank = 'Blank'
}
